import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import React, { useEffect, useState } from "react";
import { Flex, FlexProps } from "@chakra-ui/react";
import { pxToRem } from "../../../utils/styles/size";
import { useIsMobileDevice } from "../../../hooks/mobile/useIsMobileDevice";

interface SideBarContainerProps extends FlexProps {
  children?: ReactJSXElement | ReactJSXElement[];
  isExpanded?: boolean;
}
export const SideBarContainer: React.FC<SideBarContainerProps> = ({
  isExpanded,
  children,
  ...props
}) => {
  const isMobileDevice = useIsMobileDevice();
  const [animatedExpanded, setAnimatedExpanded] = useState(isExpanded);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      setAnimatedExpanded(isExpanded);
    });
    return () => cancelAnimationFrame(id);
  }, [isExpanded]);
  return (
    <Flex
      flexShrink={0}
      flexDir={"column"}
      as="nav"
      h={"full"}
      color="white"
      width={animatedExpanded ? pxToRem(250) : pxToRem(48)}
      transition="width 0.3s ease-in-out"
      bg={"#313435"}
      display={isMobileDevice ? "none" : "flex"}
      {...props}
    >
      {children}
    </Flex>
  );
};
